import { bytesConverter } from "@gemlightbox/core-kit";

export const createPageUploaderAccept =
  "image/jpeg, image/jpg, image/png, video/quicktime, video/mp4";

export const createPageMaxSizeInBytes = bytesConverter(1, "Bytes", "GB");

export const createPageMaxFiles = 50;
